module.exports = __webpack_public_path__ + "static/img/video3.dd62193a.png";